import { Suspense } from 'react'

import { cn } from '#/shared/lib/utils'
import { lazyNamed } from '#/shared/lib/version-check'
import type { MapboxMapProps } from './mapbox-map'

const importMapboxMap = () => import('./mapbox-map')

const LazyMapboxMap = lazyNamed(importMapboxMap, (m) => m.MapboxMap)

export function prefetchMapboxMap() {
  void importMapboxMap()
}

export function MapboxMap(props: MapboxMapProps) {
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            'animate-pulse rounded-md border border-gray-200 bg-gray-50',
            props.className,
          )}
        />
      }
    >
      <LazyMapboxMap {...props} />
    </Suspense>
  )
}
